import {parsePhoneNumber} from 'libphonenumber-js/min'

export const rules_mixin = {
    methods: {
        validate_mobile_number(v) {
            if (!v.startsWith('+')) {
                return this.translate('common.mobile_number_must_start_with')
            }
            try {
                const phone_number = parsePhoneNumber(v)
                this.mobile_number = phone_number.formatInternational()
                if (!phone_number.isValid()) return this.translate('common.invalid_mobile_number')
            } catch {
                return this.translate('common.invalid_mobile_number')
            }
        },
        validate_email(v) {
            const regex = new RegExp('^[\\w-\\.]+@([\\w-]+\\.)+[\\w-]{2,4}$')
            if (!regex.test(v)) return this.translate('common.invalid_email')
        },
        validate_clearing_number(v) {
            if (v.length < 4 || v.length > 5) return this.translate('common.number_of_digits', ['4-5'])
            const regex = new RegExp('^[0-9]{4,5}$')
            if (!regex.test(v)) return this.translate('common.invalid_clearing_number')
        },
        validate_account_number(v) {
            if (v.length < 5 || v.length > 15) return this.translate('common.number_of_digits', ['5-15'])
            const regex = new RegExp('^[0-9]{5,15}$')
            if (!regex.test(v)) return this.translate('common.invalid_account_number')
        },
        validate_ocr(v) {
            const trimmed = (v ?? '').trim()
            if (trimmed.length === 0) return this.translate('common.required')
            if (trimmed.length > 50) return this.translate('common.invalid_ocr_number')
        },
        validate_digits(v) {
            const regex = new RegExp('[0-9]')
            if (!regex.test(v)) return this.translate('common.invalid')
        },
        required_rule(v) {
            if (!v) {
                return this.translate('common.required')
            }

            let no_length = false
            if (v instanceof Object) {
                if (!Array.isArray(v)) {
                    no_length = !Object.keys(v).length
                } else {
                    no_length = !v.length
                }
            } else {
                no_length = !v.length
            }

            if (no_length) {
                return this.translate('common.required')
            }

            return null
        }
    },
}
